import { asyncAction } from '../../utils/actions';

export const fetchCollections = asyncAction('collections/FETCH_COLLECTIONS');
export const fetchDefaultCollection = asyncAction('collections/FETCH_DEFAULT_COLLECTION');
export const fetchCollectionBySlug = asyncAction('collections/FETCH_COLLECTION_BY_SLUG');
